import React from "react";
import { Grid } from "@material-ui/core";
import { TextValidator } from "react-material-ui-form-validator";
import styles from "./NscDeliveryRangesRow.module.scss";
import { withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import MultiToggleWidget from "../../../../../shared/toggles/multiToggleWidget/MultiToggleWidget";
import NewRangeRow from "../../shared/NewRangeRow";

const NscDeliveryRangesRow = (props) => {
  return (
    <div
      id="DeliverRangeAndPriceRow"
      className={`${styles.rowBorder} pagePaddingLeft pagePaddingRight`}
    >
      <Grid container spacing={0} alignItems="center">
        <Grid item xs={3} className={styles.rowItem}>
          <NewRangeRow {...props} />
        </Grid>
        <Grid item xs={3}>
          {props.freeDeliveryOption && (
            <div className={styles.deliveryContainer}>
              <MultiToggleWidget
                settings={{
                  acceptedText: props.t("GeneralEMP.statusYes"),
                  rejectedText: props.t("GeneralEMP.statusNo"),
                  suppClass: `${styles.toggleWrapperMain}`,
                  toggleLabel: `${styles.activationToggle}`,
                }}
                currentStatus={props.freeDelivery ? "yes" : "no"}
                onSelect={props.selectDeliveryOption}
                fromDealerTable={true}
              />
            </div>
          )}
        </Grid>
        <Grid item xs={3} className={`${styles.rowItem} ${styles.right}`}>
          <TextValidator
            className={styles.textBox}
            style={{ marginTop: "10px", marginBottom: "10px" }}
            id={props.currentRow === null ? "" : props.currentRow.toString()}
            name={"rangeValue" + props.currentRow.toString()}
            variant="outlined"
            value={
              props.dataObjItem.value === null ? "" : props.dataObjItem.value
            }
            validators={[
              "required",
              "matchRegexp:^[0-9\\b.]+$",
              "isNumber",
              "isNumericWithTwoDecimalPlaces",
            ]}
            errorMessages={[
              props.t("nscDeliveryBands.required"),
              props.t("nscDeliveryBands.invalid"),
              props.t("nscDeliveryBands.invalid"),
              props.t("nscDeliveryBands.invalid"),
            ]}
            onChange={props.action}
          />
        </Grid>
        <Grid item xs={3} className={`${styles.rowItem} ${styles.delete}`}>
          {props.currentNoOfRows > props.defaultNoOfRows &&
            props.currentRow + 1 === props.currentNoOfRows && (
              <div>
                <Button
                  id="deleteDeliveryRangeBtn"
                  className={styles.deleteButton}
                  onClick={props.deleteAction}
                  component="button"
                >
                  {props.t("nscDeliveryBands.delete")}
                </Button>
              </div>
            )}
        </Grid>
        <Grid item xs={1} />
      </Grid>
    </div>
  );
};

export default withTranslation("emp")(NscDeliveryRangesRow);
